<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="disabled" 
      color="success" 
      :loading="loading" 
      @click="fetch" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-export</v-icon> 
      Exportar
    </v-btn>

    <!-- Download Dialog -->
    <v-dialog v-model="dataReady" max-width="400" transition="scale-transition">
      <v-card class="modern-card overflow-hidden rounded-xl">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="success" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-download</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black success--text lh-1">Exportar Softnet</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Archivo CSV preparado</div>
            </div>
          </div>
        </div>

        <v-card-text class="text-center pa-8">
          <v-avatar color="success lighten-5" size="80" class="mb-6">
            <v-icon color="success" size="40">fas fa-exchange-alt</v-icon>
          </v-avatar>
          <div class="body-1 success--text font-weight-bold mb-2">¡Todo listo!</div>
          <div class="caption grey--text px-4 mb-6">Las notas de venta sincronizadas han sido procesadas para su descarga.</div>

          <vue-json-to-csv
            :json-data="items"
            :labels="labels"
            :csv-title="csvTitle"
            :separator="';'"
            @success="val => handleSuccess(val)"
            @error="val => handleError(val)">
            <v-btn 
              color="success" 
              block 
              large 
              elevation="0"
              height="48"
              class="font-weight-black text-none rounded-lg shadow-sm"
            >
              <v-icon left>fas fa-download</v-icon>
              Descargar Archivo
            </v-btn>
          </vue-json-to-csv>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-4 text-center">
          <v-btn text small color="grey" class="text-none font-weight-bold" @click="dataReady = false">Cerrar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import {fetchDocuments} from '@/api/softnet'
import VueJsonToCsv from 'vue-json-to-csv'
import moment from 'moment'

export default {
  name: "ExportDocuments",
  props: ['filter', 'options', 'disabled'],
  components: { VueJsonToCsv },
  data() {
    return {
      loading: false,
      items: [],
      dataReady: false,
      labels: {
        created_at: { title: 'Creada' },
        document: { title: 'Folio Externo' },
        workorder: { title: 'OT' },
        sales_note: { title: 'Cotización' },
        customer_name: { title: 'Cliente' },
        customer_rut: { title: 'RUT Cliente' },
        neto: { title: 'Monto Neto' },
        created_by_name: { title: 'Sincronizado por' },
      },
      csvTitle: `export_softnet_${moment(new Date().toISOString()).format('DD-MM-yyyy_HH:mm')}`
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sort = (sortBy && sortBy.length) ? sortBy[0] : '-created_at'
      
      const query = `ordering=${sortDesc && sortDesc[0] ? sort : '-' + sort}&page=1&page_size=-1&created_after=${this.filter.created_after || ''}&created_before=${this.filter.created_before || ''}&workorder__sales_note__customer__seller=${this.filter.seller || ''}`
      
      try {
        const res = await fetchDocuments(query)
        this.items = res.results.map(item => ({
          ...item,
          created_at: moment(item.created_at).format('DD/MM/yyyy'),
          neto: Math.round(item.neto)
        }))
        this.dataReady = true
      } catch (err) {
        notifications.showError('Error al procesar exportación Softnet')
      } finally {
        this.loading = false
      }
    },
    handleSuccess(val) {
      notifications.showSuccess('Documentos Softnet Exportados')
      this.dataReady = false
    },
    handleError(val) {
      notifications.showError('Error Exportando Documentos Softnet')
      this.dataReady = false
    }
  }
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; font-family: 'Outfit', sans-serif !important; }
.bg-grey-light { background-color: #f8fafc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.border-white-sm { border: 2px solid white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.h-44 { height: 44px !important; }
.lh-1 { line-height: 1 !important; }
.tracking-widest { letter-spacing: 1.5px; }
.tracking-wider { letter-spacing: 0.8px; }
</style>